import { render, staticRenderFns } from "./HornorBuyGuideNotEligible.vue?vue&type=template&id=d28fe4e6&scoped=true&"
import script from "./HornorBuyGuideNotEligible.vue?vue&type=script&lang=js&"
export * from "./HornorBuyGuideNotEligible.vue?vue&type=script&lang=js&"
import style0 from "./HornorBuyGuideNotEligible.vue?vue&type=style&index=0&id=d28fe4e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28fe4e6",
  null
  
)

export default component.exports